import React from 'react';
import { useTranslation } from 'react-i18next';

import { FAQ } from '@/modules/payment/subscription/components/FAQs/FAQ';
import { Typography } from '@/shared/components/atoms';

const ARRAY_LENGTH = 6;

const FAQs = () => {
  const { t } = useTranslation('payment');
  return (
    <div className='mt-32 flex flex-col gap-24'>
      <div className='flex flex-col gap-2'>
        <Typography
          weight='semiBold'
          variant='h2'
          className='text-text-default'
        >
          {t('asked-questions')}
        </Typography>
        <Typography variant='body1' className='text-grey-600'>
          {t('asked-questions-description')}
        </Typography>
      </div>
      <div className='mx-auto flex w-2/3 flex-col'>
        {Array.from({ length: ARRAY_LENGTH }).map((_item, idx) => (
          <FAQ
            key={idx}
            number={idx + 1}
            border={idx + 1 !== ARRAY_LENGTH}
            // TODO: check logic
            open={idx !== 0}
          />
        ))}
      </div>
    </div>
  );
};

export { FAQs };
